import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Drawer,
  IconButton,
  Button,
  TextField,
  DialogActions,
  DialogTitle,
  DialogContent,
  Dialog,
  Chip,
  DialogContentText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import InsertLinkRoundedIcon from "@mui/icons-material/InsertLinkRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { useSelector, useDispatch } from "react-redux";
import {
  changeInterviewStatus,
  changeJobApplicationStatus,
  deleteRond,
  getApplicants,
  getApplicationStatusHistory,
  getInterviewRounds,
} from "../../../../Redux/Reducers/JobReducer";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import AssignmentModal from "./AssignmentModal";
import InterviewScheduleSlider from "../InterviewScheduleSlider";

const SelectionModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Selection</DialogTitle>
    <DialogContent sx={{ width: "600px" }}>
      <TextField
        autoFocus
        margin="dense"
        label="Write remark for selection"
        fullWidth
        multiline
        rows={4}
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

const SelectModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Selection</DialogTitle>
    <DialogContent sx={{ width: "600px" }}>
      <TextField
        autoFocus
        margin="dense"
        label="Write remark for selection"
        fullWidth
        multiline
        rows={4}
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="primary" variant="contained">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

const RejectionModal = ({ open, onClose, remarks, setRemarks, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Rejection</DialogTitle>
    <DialogContent sx={{ width: "600px" }}>
      <TextField
        autoFocus
        margin="dense"
        label="Write remark for rejection"
        fullWidth
        multiline
        rows={4}
        value={remarks}
        onChange={(e) => setRemarks(e.target.value)}
      />
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Confirm
      </Button>
    </DialogActions>
  </Dialog>
);

const DeleteConfirmationDialog = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Confirm Delete</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete this round? This action cannot be
        undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="primary">
        Cancel
      </Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

const InterviewRounds = ({
  open,
  onClose,
  candidateId,
  onSchedule,
  applicant,
  onStatusUpdate,
}) => {
  const dispatch = useDispatch();
  const [rounds, setRounds] = useState([]);
  const [openSelectModal, setOpenSelectModal] = useState(false);
  const [openSelectionModal, setOpenSelectionModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [remarks, setRemarks] = useState("");
  const [selectedRoundCode, setSelectedRoundCode] = useState(null);
  const Jobs = useSelector((state) => state?.jobs?.postedJobsData);
  const postedJobs = Jobs?.posted_jobs;
  const InterviewRoundsRes = useSelector(
    (state) => state?.jobs?.interviewRounds
  );
  const RoundsUpdate = useSelector((state) => state?.jobs?.RoundsUpdate);
  const [openPdf, setPdfOpen] = useState(false);
  const [selectedAssignment, setSelectedAssignment] = useState("");
  const [editingRound, setEditingRound] = useState(null);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [viewType, setViewType] = useState("");
  const [isDeleteMode, setIsDeleteMode] = useState(false);

  // Get numbesr of rounds from job posting
  const getNoOfRounds = (applicant, postedJobs) => {
    const job = postedJobs?.find((job) => job?.id === applicant?.job_id);
    return job ? job?.no_of_rounds : null;
  };

  const isPreviousRoundSelected = (rounds, currentIndex) => {
    if (currentIndex === 0) return true;
    return rounds[currentIndex - 1]?.selection_status === "Selected";
  };

  // console.log("InterviewRoundsRes", InterviewRoundsRes, rounds)

  // Initialize rounds based on job configuration
  // useEffect(() => {
  //   const totalRounds = getNoOfRounds(applicant, postedJobs);
  //   if (totalRounds) {
  //     // Get the current number of rounds in InterviewRoundsRes
  //     const completedRoundsCount = InterviewRoundsRes?.length || 0;
  //     const totalRoundsToShow = Math.max(totalRounds, completedRoundsCount);
  //   //  console.log("totalRoundsToShow123", totalRoundsToShow, totalRounds, completedRoundsCount)
  //     const initialRounds = Array.from(
  //       { length: totalRoundsToShow },
  //       (_, index) => ({
  //         id: index + 1,
  //         name: `Round ${index + 1}`,
  //         type: "Not Scheduled",
  //         scheduled: false,
  //         status: "Pending",
  //       })
  //     );

  //     // Merge with completed rounds data
  //     const updatedRounds = initialRounds?.map((round, index) => {
  //       const completedRound = InterviewRoundsRes?.[index];
  //       if (completedRound) {
  //         return {
  //           ...round,
  //           ...completedRound,
  //           scheduled: true,
  //         };
  //       }
  //       return round;
  //     });

  //     setRounds(updatedRounds);
  //     setSelectedAssignment(updatedRounds);
  //   }
  // }, [InterviewRoundsRes, applicant, postedJobs]);

  useEffect(() => {
    if (open && candidateId) {
      dispatch(getInterviewRounds(candidateId));
    }
  }, [candidateId]);

  useEffect(() => {
    // const totalRounds = getNoOfRounds(applicant, postedJobs);
    // if (totalRounds) {
    //   const completedRoundsCount = InterviewRoundsRes?.length || 0;
    //   console.log("completedRoundsCount", completedRoundsCount)
    //   const totalRoundsToShow = Math.max(totalRounds, completedRoundsCount);

    //   const initialRounds = Array.from(
    //     { length: totalRoundsToShow },
    //     (_, index) => ({
    //       id: index + 1,
    //       name: `Round ${index + 1}`,
    //       type: "Not Scheduled",
    //       scheduled: false,
    //       status: "Pending",
    //     })
    //   );

    //   const updatedRounds = initialRounds?.map((round, index) => {
    //     const completedRound = InterviewRoundsRes[index];
    //     return completedRound
    //       ? { ...round, ...completedRound, scheduled: true }
    //       : round;
    //   });

    //   setRounds(updatedRounds);
    // }
    const completedRoundsCount = InterviewRoundsRes?.length || 0;
    const jobRounds = getNoOfRounds(applicant, postedJobs);

    // Decide how many rounds we should show: if jobRounds is present use that,
    // otherwise fall back to the number of rounds we actually received (or at least 1).
    let totalRoundsToShow = 1;
    if (jobRounds && jobRounds > 0) {
      totalRoundsToShow = Math.max(jobRounds, completedRoundsCount);
    } else if (completedRoundsCount > 0) {
      totalRoundsToShow = completedRoundsCount;
    }

    const initialRounds = Array.from(
      { length: totalRoundsToShow },
      (_, index) => ({
        id: index + 1,
        name: `Round ${index + 1}`,
        type: "Not Scheduled",
        scheduled: false,
        status: "Pending",
      })
    );

    // If we have jobRounds, overlay them with InterviewRoundsRes; if not, prefer the actual rounds received.
    let updatedRounds;
    if (jobRounds && jobRounds > 0) {
      updatedRounds = initialRounds?.map((round, index) => {
        const completedRound = InterviewRoundsRes?.[index];
        return completedRound
          ? { ...round, ...completedRound, scheduled: true }
          : round;
      });
    } else {
      // No job configured rounds, use the InterviewRoundsRes as-is (map to keep fields consistent)
      updatedRounds = InterviewRoundsRes?.map((r, idx) => ({
        id: idx + 1,
        name: r?.name || `Round ${idx + 1}`,
        ...r,
        scheduled: true,
      })) || initialRounds;
    }

    setRounds(updatedRounds);
  }, [InterviewRoundsRes, applicant, postedJobs]);


  //done on 26/11/25
  // Fetch interview rounds on component mount
  // useEffect(() => {
  //   if (candidateId) {
  //     dispatch(getInterviewRounds(candidateId));
  //   }
  // }, [candidateId]);

  // useEffect(() => {
  //   if (candidateId && rounds?.length > 0) {
  //     dispatch(getInterviewRounds(candidateId));
  //   }
  // }, [rounds]);
  //done on 26/11/25s


  // const handleScheduleClick = (roundToEdit) => {
  //   setEditingRound(roundToEdit);
  //   onClose();
  //   onSchedule();
  // };

  const handleScheduleClick = (roundToEdit = null) => {
    // Don't close the parent drawer here
    // console.log("roundToEdit", roundToEdit)
    setEditingRound(roundToEdit);
    setScheduleModalOpen(true); // Directly control the modal state
  };

  const handleSelect = (roundCode) => {
    setSelectedRoundCode(roundCode);
    setOpenSelectionModal(true);
  };

  const handleReject = (roundCode) => {
    setSelectedRoundCode(roundCode);
    setOpenRejectModal(true);
  };

  // const handleConfirmSelect = () => {
  //   dispatch(
  //     changeInterviewStatus({
  //       round_code: selectedRoundCode,
  //       selection_status: "Selected",
  //       remarks: remarks,
  //     })
  //   ).then(() => {
  //     setRounds((prevRounds) =>
  //       prevRounds?.map((round) =>
  //         round.round_code === selectedRoundCode
  //           ? { ...round, status: "Completed", selection_status: "Selected" }
  //           : round
  //       )
  //     );
  //     setOpenSelectionModal(false);
  //     setRemarks("");
  //      onClose()
  //   });
  // };


  const handleConfirmSelect = () => {
    dispatch(
      changeInterviewStatus({
        round_code: selectedRoundCode,
        selection_status: "Selected",
        remarks: remarks,
      })
    ).then(() => {
      setRounds((prevRounds) =>
        prevRounds?.map((round) =>
          round.round_code === selectedRoundCode
            ? { ...round, status: "Completed", selection_status: "Selected" }
            : round
        )
      );
      setOpenSelectionModal(false);
      setRemarks("");
      onClose();
      // NEW: refresh rounds from server to update global store and other components
      if (candidateId) {
        dispatch(getInterviewRounds(candidateId));
      }
    });
  };

  // const handleConfirmReject = () => {
  //   dispatch(
  //     changeInterviewStatus({
  //       round_code: selectedRoundCode,
  //       selection_status: "Rejected",
  //       remarks: remarks,
  //     })
  //   );
  //   setOpenRejectModal(false);
  //   setRemarks("");
  //   onClose()
  // };
  const handleConfirmReject = () => {
    dispatch(
      changeInterviewStatus({
        round_code: selectedRoundCode,
        selection_status: "Rejected",
        remarks: remarks,
      })
    ).then(() => {
      setRounds((prevRounds) =>
        prevRounds?.map((round) =>
          round.round_code === selectedRoundCode
            ? { ...round, status: "Completed", selection_status: "Rejected" }
            : round
        )
      );
      setOpenRejectModal(false);
      setRemarks("");
      onClose();
      // NEW: refresh rounds from server to update global store and other components
      if (candidateId) {
        dispatch(getInterviewRounds(candidateId));
      }
    });
  };
  const handleCloseModal = () => {
    setPdfOpen(false);
  };

  const handleViewDoc = (round, type) => {
    // const [selectedAssignment, setSelectedAssignment] = useState(null);
    console.log("roundNN", round);
    setSelectedAssignment(round);
    setViewType(type);
    setPdfOpen(true);
  };

  const handleEditRound = (round) => {
    // console.log("roundNNN", round)
    setEditingRound(round);
    setScheduleModalOpen(true);
  };

  const handleDeleteRound = (roundCode) => {
    setSelectedRoundCode(roundCode);
    setIsDeleteMode(true); // Add this state variable at the top
    setOpenDelete(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await dispatch(deleteRond(selectedRoundCode));
      // Refresh rounds data after successful deletion
      dispatch(getInterviewRounds(candidateId)); // Add this line
      setOpenDelete(false);
    } catch (error) {
      console.error("Delete round failed:", error);
    }
    handleDeleteClose();
  };

  const handleDeleteClose = () => {
    setOpenDelete(false);
    setIsDeleteMode(false);
  };

  const handleFinalInterviewed = async () => {
    const nextStatus = "Selected";

    const payload = {
      application_id: applicant?.application_id,
      status: nextStatus,
      remarks: "Not Selected", // optional: or set via `remarks` state if needed
    };

    try {
      const statusResponse = await dispatch(
        changeJobApplicationStatus(payload))
      if (statusResponse?.payload?.statusCode == 200) {
        // setLocalStatus(nextStatus);
        await Promise.all([
          dispatch(getApplicants({ job_id: applicant?.job_id })),
        
          dispatch(
            getApplicationStatusHistory({ id: applicant?.application_id })
          ),
        ]);
        console.log("Status Updated kjnsckjl")
        onStatusUpdate?.("Selected")
        setOpenSelectModal(false);
        setRemarks("");
        onClose();
      }
    } catch (error) {
      console.error("Error updating to Interviewed:", error);
    }
  };

  const allRoundsSelected =
    rounds?.length > 0 &&
    rounds.every(
      (round) =>
        !round.scheduled || // Include unscheduled rounds
        (round.scheduled && round.selection_status === "Selected") // Check scheduled rounds are selected
    );

  // Render round card content
  const RoundCard = ({ round, index }) => {
    const currentTime = new Date();
    let cutoffTime = new Date();

    // Determine cutoff time based on round type
    if (round?.type === "Assignment") {
      cutoffTime = new Date(round?.deadline);
    } else if (round?.interview_schedule?.end_time) {
      cutoffTime = new Date(round?.interview_schedule?.end_time);
    }

    const canActOnRound = (rounds, currentIndex) => {
      if (currentIndex === 0) return true;
      if (!rounds[currentIndex - 1]) return false;
      return rounds[currentIndex - 1]?.selection_status === "Selected";
    };

    // Check if the current time is past the cutoff time
    const isTimeEnded = currentTime > cutoffTime;
    const isActive = canActOnRound(rounds, index);
    const showActionButtons =
      round?.scheduled && !round?.selection_status && isTimeEnded;

    return (
      <Box
        sx={{
          mb: 2,
          p: 2,
          borderRadius: "8px",
          border: "1px solid #e0e0e0",
          transition: "all 0.3s ease",
          backgroundColor: round?.scheduled ? "#f5f5f5" : "#E3F2FD",
          opacity: isActive ? 1 : 0.7,
          opacity: 1,
          // pointerEvents: index === 0 || (index > 0 && rounds[index - 1]?.selection_status === 'Selected') ? 'auto' : 'none',
          pointerEvents: canActOnRound ? "auto" : "none",
          "&:hover": {
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderColor: "#0044C6",
          },
        }}
      >
        {/* Round Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="subtitle1" fontWeight="bold" color="#0044C6">
            {round?.name}
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
            {round?.selection_status && (
              <Typography
                sx={{
                  fontSize: "0.875rem",
                  color:
                    round?.selection_status === "Selected" ? "green" : "red",
                }}
              >
                {round?.selection_status}
              </Typography>
            )}
            {round?.scheduled &&
              !round?.selection_status &&
              !openDelete &&
              !showActionButtons && (
                <>
                  <IconButton
                    onClick={() => handleEditRound(round)}
                    size="small"
                    sx={{
                      p: 0.5,
                      color: isActive
                        ? "text.secondary"
                        : "rgba(0, 0, 0, 0.26)",
                      cursor: isActive ? "pointer" : "not-allowed",
                    }}
                    disabled={!isActive}
                  >
                    <EditRoundedIcon fontSize="small" />
                  </IconButton>
                  <IconButton
                    onClick={() =>
                      isActive ? handleDeleteRound(round?.round_code) : null
                    }
                    size="small"
                    sx={{
                      p: 0.5,
                      color: isActive
                        ? "text.secondary"
                        : "rgba(0, 0, 0, 0.26)",
                      cursor: isActive ? "pointer" : "not-allowed",
                    }}
                    disabled={!isActive}
                  >
                    <DeleteRoundedIcon fontSize="small" />
                  </IconButton>
                </>
              )}
          </Box>
        </Box>

        {/* Round Details */}
        <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
          Type: {round?.type === "F2F" ? "Face to Face" : round?.type}
        </Typography>

        {/* Scheduled Round Information */}
        {round?.scheduled && (
         
          <RoundDetails
            round={round}
            key={`${round?.id}-${round?.scheduled}-${round?.selection_status}`}
          />
        )}

        {/* Action Buttons - Only show after cutoff time */}
        {/* {round?.scheduled && !round?.selection_status && isTimeEnded && ( */}
        {showActionButtons && (
          <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
            <Button
              variant="contained"
              fullWidth
              color="error"
              onClick={() => handleReject(round?.round_code)}
              disabled={!isActive}
            >
              Reject
            </Button>
            
            <Button
              variant="contained"
              fullWidth
              sx={{ bgcolor: "#0044C6" }}
              onClick={() => handleSelect(round?.round_code)}
              disabled={!isActive}
            >
              Select
            </Button>
          </Box>
        )}

        {/* Schedule Button for Unscheduled Rounds */}
        {!round?.scheduled && (
          <Button
            variant="contained"
            fullWidth
            sx={{ mt: 2, bgcolor: "#0044C6" }}
            onClick={handleScheduleClick}
          >
            Schedule Round
          </Button>
        )}
      </Box>
    );
  };

  const RoundDetails = ({ round }) => (
    console.log("roundDetails", round),
    <>
      {round?.type === "F2F" && round?.interview_schedule && (
        <>
          <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
            Date:{" "}
            {new Date(
              round?.interview_schedule?.start_time
            ).toLocaleDateString()}
          </Typography>
          <Typography variant="body2" sx={{ color: "#666" }}>
            Time:{" "}
            {new Date(
              round?.interview_schedule?.start_time
            ).toLocaleTimeString()}{" "}
            -
            {new Date(round?.interview_schedule?.end_time).toLocaleTimeString()}
          </Typography>
          <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
            Location: {round?.interview_location}
          </Typography>
          <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
            Description: {round?.description}
          </Typography>

          {/* Interviewer Details for F2F */}
          {round?.interviewers_list && (
            <Box sx={{ mt: 2, borderTop: "1px solid #eee", pt: 2 }}>
              <Typography
                variant="body2"
                sx={{ color: "#666", fontWeight: "bold", mb: 1 }}
              >
                Interviewer Details:
              </Typography>
              {round?.interviewers_list?.map((interviewer, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 1,
                    p: 1,
                    borderRadius: "4px",
                    backgroundColor: "rgba(0, 68, 198, 0.05)",
                  }}
                >
                  <Box
                    component="img"
                    src={
                      interviewer?.profile_url ||
                      "https://static.vecteezy.com/system/resources/thumbnails/009/734/564/small_2x/default-avatar-profile-icon-of-social-media-user-vector.jpg"
                    }
                    alt={`${interviewer?.first_name}'s profile`}
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      {interviewer?.first_name || "User"}{" "}
                      {interviewer?.last_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#666" }}>
                      {interviewer?.designation}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
        </>
      )}

      {round?.type === "Remote" && round?.interview_schedule && (
        <>
          <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
            Date:{" "}
            {new Date(
              round?.interview_schedule?.start_time
            ).toLocaleDateString()}
          </Typography>
          <Typography variant="body2" sx={{ color: "#666" }}>
            Time:{" "}
            {new Date(
              round?.interview_schedule?.start_time
            ).toLocaleTimeString()}{" "}
            -
            {new Date(round?.interview_schedule?.end_time).toLocaleTimeString()}
          </Typography>

          {/* Interviewer Details for Remote */}
          {round?.interviewers_list && (
            <Box sx={{ mt: 2, mb: 2, borderTop: "1px solid #eee", pt: 2 }}>
              <Typography
                variant="body2"
                sx={{ color: "#666", fontWeight: "bold", mb: 1 }}
              >
                Interviewer Details:
              </Typography>
              {round?.interviewers_list?.map((interviewer, idx) => (
                <Box
                  key={idx}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mb: 1,
                    p: 1,
                    borderRadius: "4px",
                    backgroundColor: "rgba(0, 68, 198, 0.05)",
                  }}
                >
                  <Box
                    component="img"
                    src={
                      interviewer?.profile_url ||
                      "https://static.vecteezy.com/system/resources/thumbnails/009/734/564/small_2x/default-avatar-profile-icon-of-social-media-user-vector.jpg"
                    }
                    alt={`${interviewer?.first_name}'s profile`}
                    sx={{
                      width: 40,
                      height: 40,
                      borderRadius: "50%",
                      objectFit: "cover",
                    }}
                  />
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                      {interviewer?.first_name || "User"}{" "}
                      {interviewer?.last_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: "#666" }}>
                      {interviewer?.designation}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          )}
          <Typography
            component="a"
            href={round?.interview_schedule?.meet_link}
            target="_blank"
            sx={{
              mt: 1,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
              color: "#0044C6",
              "&:hover": { color: "#003399" },
            }}
          >
            <InsertLinkRoundedIcon
              sx={{ color: "#0044C6", marginRight: "5px" }}
            />
            Join Meeting
          </Typography>
        </>
      )}

      {round?.type === "Assignment" && (
        <>
          <Typography variant="body2" sx={{ color: "#666", mt: 1 }}>
            Deadline:{" "}
            {round?.deadline
              ? new Date(round?.deadline).toLocaleString()
              : "No deadline set"}
          </Typography>
          {round?.description && (
            <Typography variant="body2" sx={{ color: "#666", mt: 0.5 }}>
              Description: {round?.description}
            </Typography>
          )}
          {round.assignment_file_type === "application/pdf" ||
            round.assignment_file_type?.startsWith("image/") ? (
            <Typography
              component="a"
              href={round.assignment_file}
              onClick={(e) => {
                e.preventDefault();
                handleViewDoc(round, "Assignment");
              }}
              sx={{
                mt: 1,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                textDecoration: "none",
                color: "#0044C6",
                "&:hover": { color: "#003399" },
              }}
            >
              <AssignmentRoundedIcon
                sx={{ color: "#0044C6", marginRight: "5px" }}
              />
              View Assignment
            </Typography>
          ) : (
            <Typography
              component="a"
              href={round.assignment_file}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                mt: 1,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                textDecoration: "none",
                color: "#0044C6",
                "&:hover": { color: "#003399" },
              }}
            >
              <AssignmentRoundedIcon
                sx={{ color: "#0044C6", marginRight: "5px" }}
              />
              Check Assignment
            </Typography>
          )}
        </>
      )}
      <hr />
      {round?.submission_file &&
        (round?.submission_file_type === "application/pdf" ||
          round?.submission_file_type?.startsWith("image/") ? (
          <Typography
            component="a"
            href={round?.submission_file}
            onClick={(e) => {
              e.preventDefault();
              handleViewDoc(round, "submission");
            }}
            sx={{
              mt: 1,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
              color: "#0044C6",
              "&:hover": { color: "#003399" },
            }}
          >
            View Submission
          </Typography>
        ) : (
          <Typography
            component="a"
            href={round?.submission_file}
            target="_blank"
            sx={{
              mt: 1,
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              textDecoration: "none",
              color: "#0044C6",
              "&:hover": { color: "#003399" },
            }}
          >
            <AssignmentRoundedIcon
              sx={{ color: "#0044C6", marginRight: "5px" }}
            />
            Download Assignment
          </Typography>
        ))}
    </>
  );

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      sx={{
        "& .MuiDrawer-paper": {
          width: "400px",
          padding: "20px",
          // background: '#FFFFFF',
        },
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%" }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 3,
            borderBottom: "1px solid #eee",
            pb: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h6" fontWeight="bold">
              Interview Rounds
            </Typography>
            {allRoundsSelected && rounds?.some((round) => round.scheduled) && (
              <>
                <Button
                  variant="outlined"
                  onClick={() => setOpenSelectModal(true)}
                >
                  Mark as Interviewed
                </Button>
                <SelectModal
                  open={openSelectModal}
                  onClose={() => setOpenSelectModal(false)}
                  remarks={remarks}
                  setRemarks={setRemarks}
                  onConfirm={handleFinalInterviewed}
                />
              </>
            )}
          </Box>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Content */}
        <Box sx={{ flex: 1, overflowY: "auto", px: 1 }}>
          {rounds?.map((round, index) => (
            <RoundCard key={round?.id} round={round} index={index} />
          ))}
        </Box>

        {/* Footer */}
        <Box sx={{ mt: 3, display: "flex", flexDirection: "column", gap: 2 }}>
          <Button
            variant="contained"
            fullWidth
            sx={{ bgcolor: "#0044C6" }}
            onClick={() => handleScheduleClick()} // Pass no argument for new round
            disabled={
              rounds?.length > 0 &&
              !rounds[rounds?.length - 1]?.selection_status
            }
          >
            {rounds?.length === 0
              ? "Add First Interview Round"
              : "Add New Interview Round"}
          </Button>
          <Button
            onClick={onClose}
            variant="outlined"
            fullWidth
            sx={{ color: "gray", borderColor: "gray" }}
          >
            Cancel
          </Button>
        </Box>
      </Box>

      <SelectionModal
        open={openSelectionModal}
        onClose={() => setOpenSelectionModal(false)}
        remarks={remarks}
        setRemarks={setRemarks}
        onConfirm={handleConfirmSelect}
      />

      <AssignmentModal
        viewType={viewType}
        openPdf={openPdf}
        onClose={handleCloseModal}
        application_id={selectedAssignment?.application_id}
        assignment_file={selectedAssignment?.assignment_file}
        assignment_file_type={selectedAssignment?.assignment_file_type}
        submission_file={selectedAssignment?.submission_file}
        submission_file_type={selectedAssignment?.submission_file_type}
      />

      <InterviewScheduleSlider
        open={scheduleModalOpen}
        onClose={() => {
          setScheduleModalOpen(false);
          setEditingRound(null);
        }}
        candidateId={candidateId}
        existingRound={editingRound?.round_code}
        isEditMode={!!editingRound}
        applicant={applicant}
      />

      <RejectionModal
        open={openRejectModal}
        onClose={() => setOpenRejectModal(false)}
        remarks={remarks}
        setRemarks={setRemarks}
        onConfirm={handleConfirmReject}
      />

      <DeleteConfirmationDialog
        open={openDelete}
        onClose={() => setOpenDelete(false)}
        onConfirm={() => handleConfirmDelete()}
      />
    </Drawer>
  );
};

export default InterviewRounds;
